import axiosInstance from "../Services/Api/axiosInstance"

export const getComplaintsTable = async () => {
  try {
    const res = await axiosInstance.get('/complaints-table');
    return res.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error fetching complaints table");
  }
}


export const createComplaint = async (payload) => {
  try {
    const res = await axiosInstance.post('/complaints', { payload });
    return res.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error creating complaint");
  }
};

export const lookupSearch = async (object, q) => {
  try {
    const res = await axiosInstance.get('/complaints-lookup', {
      params: { object, q },
    });
    return res.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error fetching lookup results");
  }
};

export const getCompliantDetails = async(id) => {
  try {
    const res = await axiosInstance.get(`/complaints-details/${id}`);
    return res.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error fetching complaint details");
  }
}